import React from 'react';

import { useTranslation } from 'react-i18next';

import { TRANSLATIONS_REQUESTS } from '../../../../../../shared/translations/requests';

import './MaterialRequestDetails.scss';

interface IMaterialRequestDetails {
  collaborator: string;
  name: string;
  type: string;
  description: string;
}

interface IMaterialRequestDetailsProps {
  request: IMaterialRequestDetails;
}

const MaterialRequestDetails = ({ request }: IMaterialRequestDetailsProps) => {
  const { t } = useTranslation();
  return (
    <div className="material-request-details" data-experience="new">
      <div className="mrd-title">{t(TRANSLATIONS_REQUESTS.details.material.title)}</div>
      <div className="mrd-content flex flex-col gap-10">
        <div className="mrd-grid">
          <div className="mrd-grid-item">
            <p className="label">{t(TRANSLATIONS_REQUESTS.details.material.collaboratorLabel)}</p>
            <p className="value">{request.collaborator}</p>
          </div>
          <div className="mrd-grid-item">
            <p className="label">{t(TRANSLATIONS_REQUESTS.details.material.materialLabel)}</p>
            <p className="value">{request.name}</p>
          </div>
          <div className="mrd-grid-item">
            <p className="label">{t(TRANSLATIONS_REQUESTS.details.material.typeLabel)}</p>
            <p className="value">{request.type}</p>
          </div>
        </div>
        <div className="flex flex-col gap-1">
          <p className="label">{t(TRANSLATIONS_REQUESTS.details.material.descriptionLabel)}</p>
          <p className="value">{request.description}</p>
        </div>
      </div>
    </div>
  );
};

export default MaterialRequestDetails;
